/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureAnnotation } from './CaptureAnnotation';
import {
    CaptureAnnotationFromJSON,
    CaptureAnnotationFromJSONTyped,
    CaptureAnnotationToJSON,
    CaptureAnnotationToJSONTyped,
} from './CaptureAnnotation';

/**
 * 
 * @export
 * @interface CreateManualCaptureRequest
 */
export interface CreateManualCaptureRequest {
    /**
     * 
     */
    hostname?: string | null;
    /**
     * 
     */
    annotation?: CaptureAnnotation | null;
}

/**
 * Check if a given object implements the CreateManualCaptureRequest interface.
 */
export function instanceOfCreateManualCaptureRequest(value: object): value is CreateManualCaptureRequest {
    return true;
}

export function CreateManualCaptureRequestFromJSON(json: any): CreateManualCaptureRequest {
    return CreateManualCaptureRequestFromJSONTyped(json, false);
}

export function CreateManualCaptureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateManualCaptureRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hostname': json['hostname'] === undefined ? undefined : json['hostname'] === null ? null : json['hostname'],
        'annotation': json['annotation'] === undefined ? undefined : json['annotation'] === null ? null : CaptureAnnotationFromJSON(json['annotation']),
    };
}

export function CreateManualCaptureRequestToJSON(json: any): CreateManualCaptureRequest {
    return CreateManualCaptureRequestToJSONTyped(json, false);
}

export function CreateManualCaptureRequestToJSONTyped(value?: CreateManualCaptureRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostname': value['hostname'],
        'annotation': CaptureAnnotationToJSON(value['annotation']),
    };
}

